import { IInitAction } from './init'
import { UserDateType } from './date'

// Action types
export enum types {
  CREATE_MEDIA_TYPE_GROUP__STARTED = 'CREATE_MEDIA_TYPE_GROUP__STARTED',
  CREATE_MEDIA_TYPE_GROUP__SUCCESS = 'CREATE_MEDIA_TYPE_GROUP__SUCCESS',
  CREATE_MEDIA_TYPE_GROUP__FAILURE = 'CREATE_MEDIA_TYPE_GROUP__FAILURE',
  UPDATE_MEDIA_TYPE_GROUP__STARTED = 'UPDATE_MEDIA_TYPE_GROUP__STARTED',
  UPDATE_MEDIA_TYPE_GROUP__SUCCESS = 'UPDATE_MEDIA_TYPE_GROUP__SUCCESS',
  UPDATE_MEDIA_TYPE_GROUP__FAILURE = 'UPDATE_MEDIA_TYPE_GROUP__FAILURE',
  DELETE_MEDIA_TYPE_GROUP__STARTED = 'DELETE_MEDIA_TYPE_GROUP__STARTED',
  DELETE_MEDIA_TYPE_GROUP__SUCCESS = 'DELETE_MEDIA_TYPE_GROUP__SUCCESS',
  DELETE_MEDIA_TYPE_GROUP__FAILURE = 'DELETE_MEDIA_TYPE_GROUP__FAILURE',
  GET_MEDIA_TYPE_GROUP_BY_ID__STARTED = 'GET_MEDIA_TYPE_GROUP_BY_ID__STARTED',
  GET_MEDIA_TYPE_GROUP_BY_ID__SUCCESS = 'GET_MEDIA_TYPE_GROUP_BY_ID__SUCCESS',
  GET_MEDIA_TYPE_GROUP_BY_ID__FAILURE = 'GET_MEDIA_TYPE_GROUP_BY_ID__FAILURE',
}

export interface ICreateMediaTypeGroupAction {
  type: types.CREATE_MEDIA_TYPE_GROUP__STARTED
  mediaTypeGroupData: IMediaTypeGroup
}

export interface ICreateMediaTypeGroupSuccessAction {
  type: types.CREATE_MEDIA_TYPE_GROUP__SUCCESS
  mediaTypeGroupData: IMediaTypeGroup
  message: string
}

export interface IGetMediaTypeGroupByIdAction {
  type: types.GET_MEDIA_TYPE_GROUP_BY_ID__STARTED
  id: string
}

export interface IGetMediaTypeGroupByIdSuccessAction {
  type: types.GET_MEDIA_TYPE_GROUP_BY_ID__SUCCESS
  mediaTypeGroupData: IMediaTypeGroup
}

export interface IUpdateMediaTypeGroupAction {
  type: types.UPDATE_MEDIA_TYPE_GROUP__STARTED
  mediaTypeGroupData: IMediaTypeGroup
}

export interface IUpdateMediaTypeGroupSuccessAction {
  type: types.UPDATE_MEDIA_TYPE_GROUP__SUCCESS
  mediaTypeGroupData: IMediaTypeGroup
  message: string
}

export interface IDeleteMediaTypeGroupAction {
  type: types.DELETE_MEDIA_TYPE_GROUP__STARTED
  id: string
}

export interface IDeleteMediaTypeGroupSuccessAction {
  type: types.DELETE_MEDIA_TYPE_GROUP__SUCCESS
  message: string
}

export interface IFailureAction {
  type:
    | types.CREATE_MEDIA_TYPE_GROUP__FAILURE
    | types.GET_MEDIA_TYPE_GROUP_BY_ID__FAILURE
    | types.UPDATE_MEDIA_TYPE_GROUP__FAILURE
    | types.DELETE_MEDIA_TYPE_GROUP__FAILURE
  message: string
}

export type MediaTypeGroupActionsType =
  | ICreateMediaTypeGroupAction
  | ICreateMediaTypeGroupSuccessAction
  | IGetMediaTypeGroupByIdAction
  | IGetMediaTypeGroupByIdSuccessAction
  | IUpdateMediaTypeGroupAction
  | IUpdateMediaTypeGroupSuccessAction
  | IDeleteMediaTypeGroupAction
  | IDeleteMediaTypeGroupSuccessAction
  | IFailureAction
  | IInitAction

export interface IMediaTypeGroup extends UserDateType {
  isLoading?: boolean
  message?: string
  id: string
  title: string
  description: string
  types: Array<{ extension: string }>
}
